var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSingleScheduleIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8751 12C15.0138 12 15.9438 12.8955 15.9976 14.0214L16 14.1243V14.5C16 16.3778 15.0292 17.7834 13.5399 18.6901C12.0755 19.5816 10.107 20 8 20C5.89305 20 3.92455 19.5816 2.4601 18.6901C1.01596 17.8109 0.0593144 16.4625 0.00266171 14.6694L0 14.5V14.1245C0 12.9852 0.896475 12.0561 2.02202 12.0024L2.12495 12H13.8751ZM8 0C10.7614 0 13 2.23857 13 5C13 7.7614 10.7614 10 8 10C5.2386 10 3 7.7614 3 5C3 2.23857 5.2386 0 8 0Z",
    fill: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSingleScheduleIcon);
export default __webpack_public_path__ + "static/media/single_schedule_icon.022064b6f2d6dcf910e37483b42be219.svg";
export { ForwardRef as ReactComponent };